/**
  * THIS IS A GENERATED FILE. DO NOT ALTER DIRECTLY.
  */

 ;
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgNote = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" fillRule="evenodd" d="M6.313 3H13l6 6v10.313C19 21 17.688 21 17.688 21H6.313C5 21 5 19.313 5 19.313V4.688S5 3 6.313 3m11.375 16.313.002-9.66-5-4.96-6.377-.005v14.625z" clipRule="evenodd" /><path fill="currentColor" fillRule="evenodd" d="M16 12H8v-1.5h8zM9.5 9H8V7.5h1.5zM16 15H8v-1.5h8zM16 18H8v-1.5h8z" clipRule="evenodd" /></svg>;
export default SvgNote;